// src/pages/Workflows/Editor/components/WorkflowCanvas.js
// Centro do Editor: canvas React Flow

import React, { useCallback, useRef } from 'react';
import ReactFlow, {
  Background,
  Controls,
  MiniMap,
  BackgroundVariant,
} from 'reactflow';
import 'reactflow/dist/style.css';

import WorkflowNodeComponent from './nodes/WorkflowNodeComponent';
import { NODE_DEFINITIONS } from '../utils/nodeDefinitions';

const nodeTypes = {
  workflowNode: WorkflowNodeComponent,
};

export default function WorkflowCanvas({
  nodes,
  edges,
  onNodesChange,
  onEdgesChange,
  onConnect,
  isValidConnection,
  onNodeClick,
  onAddNode,
}) {
  const reactFlowWrapper = useRef(null);
  const [reactFlowInstance, setReactFlowInstance] = React.useState(null);

  const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'copy';
  }, []);

  const onDrop = useCallback((event) => {
    event.preventDefault();
    const tipo = event.dataTransfer.getData('application/workflow-node-type');
    if (!tipo || !NODE_DEFINITIONS[tipo]?.enabled) return;

    if (!reactFlowInstance) return;

    // screenToFlowPosition já desconta os bounds do canvas internamente — passar
    // coordenadas de ecrã puras. Subtrair os bounds aqui colocava o nó desviado
    // da posição do rato (largura da paleta + altura do header).
    const position = reactFlowInstance.screenToFlowPosition({
      x: event.clientX,
      y: event.clientY,
    });

    onAddNode(tipo, position);
  }, [reactFlowInstance, onAddNode]);

  const handleNodeClick = useCallback((event, node) => {
    onNodeClick(node);
  }, [onNodeClick]);

  const handlePaneClick = useCallback(() => {
    onNodeClick(null);
  }, [onNodeClick]);

  return (
    <div ref={reactFlowWrapper} className="wf-canvas-wrapper">
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        isValidConnection={isValidConnection}
        nodeTypes={nodeTypes}
        onInit={setReactFlowInstance}
        onDrop={onDrop}
        onDragOver={onDragOver}
        onNodeClick={handleNodeClick}
        onPaneClick={handlePaneClick}
        fitView
        deleteKeyCode="Delete"
        selectionKeyCode="Shift"
        multiSelectionKeyCode="Meta"
      >
        <Background variant={BackgroundVariant.Dots} gap={20} size={1} color="#e2e8f0" />
        <Controls />
        <MiniMap nodeColor={(node) => {
          const def = NODE_DEFINITIONS[node.data?.nodeType];
          if (!def) return '#94a3b8';
          const cores = { entrada: '#3b82f6', processamento: '#8b5cf6', pesquisa: '#10b981', saida: '#f97316' };
          return cores[def.categoria] || '#94a3b8';
        }} />
      </ReactFlow>
    </div>
  );
}
